import { Instagram, Mail } from "lucide-react";

const Footer = () => {
  return (
    <footer data-testid="site-footer" className="mt-24 border-t border-border/60 bg-secondary/40">
      <div className="mx-auto max-w-[1400px] px-5 lg:px-10 py-14 grid gap-10 md:grid-cols-3">
        <div>
          <div className="font-serif text-3xl leading-none">
            <span className="text-[#B8935F]">Kay's</span>{" "}
            <span className="italic text-[#8B6B47] font-light">Beauty Hair</span>
          </div>
          <p className="mt-4 text-sm text-muted-foreground max-w-xs leading-relaxed">
            Luxury human hair, finished by hand. Crafted for the woman who
            notices every detail.
          </p>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.25em] text-foreground/70 font-semibold mb-4">
            Shop
          </div>
          <ul className="space-y-2 text-sm">
            <li>
              <a
                data-testid="footer-shop-link"
                href="https://kays-beauty-hair.myshopify.com/collections/all"
                target="_blank"
                rel="noopener noreferrer"
                className="text-foreground/80 hover:text-[hsl(var(--primary))] link-underline"
              >
                All wigs
              </a>
            </li>
            <li>
              <a
                href="#catalog"
                className="text-foreground/80 hover:text-[hsl(var(--primary))] link-underline"
              >
                Browse by filter
              </a>
            </li>
            <li>
              <a
                href="https://kays-beauty-hair.myshopify.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-foreground/80 hover:text-[hsl(var(--primary))] link-underline"
              >
                Visit our shop
              </a>
            </li>
          </ul>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.25em] text-foreground/70 font-semibold mb-4">
            Stay in touch
          </div>
          <div className="flex items-center gap-4">
            <a
              data-testid="footer-instagram"
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="text-foreground/70 hover:text-[hsl(var(--primary))]"
            >
              <Instagram className="w-5 h-5" />
            </a>
            <a
              data-testid="footer-email"
              href="mailto:hello@kaysbeautyhair.com"
              aria-label="Email"
              className="text-foreground/70 hover:text-[hsl(var(--primary))]"
            >
              <Mail className="w-5 h-5" />
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-border/60">
        <div className="mx-auto max-w-[1400px] px-5 lg:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-muted-foreground">
          <div>© {new Date().getFullYear()} Kay's Beauty Hair. All rights reserved.</div>
          <div>Checkout powered by our Shopify store.</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
